import { render, staticRenderFns } from "./LeftArrow.vue?vue&type=template&id=7022ba33&scoped=true"
import script from "./LeftArrow.vue?vue&type=script&lang=js"
export * from "./LeftArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7022ba33",
  null
  
)

export default component.exports